/**
 * All JavaScript required for readmore
 *
 * @component readmore
 */

class Readmore {

    constructor() {
        let self = this;
        self.init();
    }

    init() {
        let self = this;

        if ($('[data-read-more]').length === 0) return;

        $('[data-read-more]').each(function (index, item) {
            const $item = $(item);

            $item.find('.c-read-more__button').on('click', function () {

                $(this).next('.c-read-more__content').toggleClass('is-active');
                $(this).prev('.u-ellipsis').css('display','none');
                $(this).css('display', 'none');

            });

        });

        if ($('[data-read-less]').length === 0) return;

        $('[data-read-less]').each(function (index, item) {
            const $item = $(item);

            $item.find('.c-read-less__button').on('click', function () {

                $(this).parent('.c-read-more__content').toggleClass('is-active');
                $(this).closest('[data-read-more]').find('.c-read-more__button').css('display','inline-block');
                $(this).closest('[data-read-more]').find('.u-ellipsis').css('display','inline-block');

            })
        })
    }

}

export default new Readmore();
